"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditAuditProduct = exports.AuditProductFilter = void 0;
const mobx_1 = require("mobx");
const audit_lot_1 = require("./audit-lot");
class AuditProductFilter {
    constructor(filter) {
        this.onlyNewProducts = false;
        this.setCategoryIds = (categoryIds) => {
            this.categoryIds = categoryIds;
        };
        this.setSupplierIds = (supplierIds) => {
            this.supplierIds = supplierIds;
        };
        this.setIsInStock = (isInStock) => {
            this.isInStock = isInStock;
        };
        this.setStartDate = (startDate) => {
            this.startDate = startDate;
        };
        this.setEndDate = (endDate) => {
            this.endDate = endDate;
        };
        this.setOnlyNewProducts = (includeNewProducts) => {
            this.onlyNewProducts = includeNewProducts;
        };
        this.setCategoryIds(filter.categoryIds);
        this.setSupplierIds(filter.supplierIds);
        this.setIsInStock(filter.isInStock);
        this.setStartDate(filter.startDate);
        this.setEndDate(filter.endDate);
        this.setOnlyNewProducts(filter.onlyNewProducts);
    }
}
__decorate([
    mobx_1.observable
], AuditProductFilter.prototype, "categoryIds", void 0);
__decorate([
    mobx_1.observable
], AuditProductFilter.prototype, "supplierIds", void 0);
__decorate([
    mobx_1.observable
], AuditProductFilter.prototype, "startDate", void 0);
__decorate([
    mobx_1.observable
], AuditProductFilter.prototype, "endDate", void 0);
__decorate([
    mobx_1.observable
], AuditProductFilter.prototype, "isInStock", void 0);
__decorate([
    mobx_1.observable
], AuditProductFilter.prototype, "onlyNewProducts", void 0);
__decorate([
    mobx_1.action
], AuditProductFilter.prototype, "setCategoryIds", void 0);
__decorate([
    mobx_1.action
], AuditProductFilter.prototype, "setSupplierIds", void 0);
__decorate([
    mobx_1.action
], AuditProductFilter.prototype, "setIsInStock", void 0);
__decorate([
    mobx_1.action
], AuditProductFilter.prototype, "setStartDate", void 0);
__decorate([
    mobx_1.action
], AuditProductFilter.prototype, "setEndDate", void 0);
__decorate([
    mobx_1.action
], AuditProductFilter.prototype, "setOnlyNewProducts", void 0);
exports.AuditProductFilter = AuditProductFilter;
class EditAuditProduct {
    constructor(json) {
        this.mappedBatches = new Map();
        this.setBatches = (batches) => {
            batches.forEach((batch) => this.mappedBatches.set(batch.id, new audit_lot_1.EditAuditBatch(batch)));
        };
        this.locallySaveEnteredQuantity = (enteredQuantity) => {
            this.locallySavedEnteredQuantity = enteredQuantity;
        };
        this.locallySaveNotes = (notes) => {
            this.locallySavedNotes = notes;
        };
        this.id = json.id;
        this.sku = json.sku;
        this.barcode = json.barcode;
        this.productId = json.productId;
        this.productName = json.productName;
        this.expectedQuantity = json.expectedQuantity;
        this.enteredQuantity = json.enteredQuantity;
        this.locallySavedEnteredQuantity = json.enteredQuantity;
        this.notes = json.notes;
        this.locallySavedNotes = json.notes;
        this.isBatchTracked = json.isBatchTracked;
        this.purchasePrice = json.purchasePrice;
        this.setBatches(json.batches);
    }
    removeBatch(id) {
        this.mappedBatches.delete(id);
    }
    addBatch(batch) {
        // Check if the new batch is already included in batches
        const existingAuditBatch = this.mappedBatches.get(batch.id);
        if (existingAuditBatch) {
            return existingAuditBatch;
        }
        const newBatch = new audit_lot_1.EditAuditBatch({
            id: batch.id,
            inventoryAuditProductId: batch.inventoryAuditProductId,
            batchId: batch.batchId,
            batchNumber: batch.batchNumber,
            expectedQuantity: batch.quantityRemaining,
            enteredQuantity: null,
        });
        this.mappedBatches.set(batch.id, newBatch);
        return newBatch;
    }
    setEnteredQuantity(enteredQuantity) {
        this.enteredQuantity = enteredQuantity;
    }
    setNotes(notes) {
        this.notes = notes;
    }
    get batchQuantitySum() {
        return this.batches.reduce((prev, curr) => prev + (curr.enteredQuantity || 0), 0);
    }
    get batches() {
        return [...this.mappedBatches.values()];
    }
}
__decorate([
    mobx_1.observable
], EditAuditProduct.prototype, "id", void 0);
__decorate([
    mobx_1.observable
], EditAuditProduct.prototype, "sku", void 0);
__decorate([
    mobx_1.observable
], EditAuditProduct.prototype, "barcode", void 0);
__decorate([
    mobx_1.observable
], EditAuditProduct.prototype, "productId", void 0);
__decorate([
    mobx_1.observable
], EditAuditProduct.prototype, "productName", void 0);
__decorate([
    mobx_1.observable
], EditAuditProduct.prototype, "expectedQuantity", void 0);
__decorate([
    mobx_1.observable
], EditAuditProduct.prototype, "enteredQuantity", void 0);
__decorate([
    mobx_1.observable
], EditAuditProduct.prototype, "locallySavedEnteredQuantity", void 0);
__decorate([
    mobx_1.observable
], EditAuditProduct.prototype, "notes", void 0);
__decorate([
    mobx_1.observable
], EditAuditProduct.prototype, "locallySavedNotes", void 0);
__decorate([
    mobx_1.observable
], EditAuditProduct.prototype, "updateDate", void 0);
__decorate([
    mobx_1.observable
], EditAuditProduct.prototype, "isBatchTracked", void 0);
__decorate([
    mobx_1.observable
], EditAuditProduct.prototype, "purchasePrice", void 0);
__decorate([
    mobx_1.observable
], EditAuditProduct.prototype, "mappedBatches", void 0);
__decorate([
    mobx_1.action
], EditAuditProduct.prototype, "removeBatch", null);
__decorate([
    mobx_1.action
], EditAuditProduct.prototype, "addBatch", null);
__decorate([
    mobx_1.action
], EditAuditProduct.prototype, "setBatches", void 0);
__decorate([
    mobx_1.action
], EditAuditProduct.prototype, "setEnteredQuantity", null);
__decorate([
    mobx_1.action
], EditAuditProduct.prototype, "locallySaveEnteredQuantity", void 0);
__decorate([
    mobx_1.action
], EditAuditProduct.prototype, "setNotes", null);
__decorate([
    mobx_1.action
], EditAuditProduct.prototype, "locallySaveNotes", void 0);
__decorate([
    mobx_1.computed
], EditAuditProduct.prototype, "batchQuantitySum", null);
__decorate([
    mobx_1.computed
], EditAuditProduct.prototype, "batches", null);
exports.EditAuditProduct = EditAuditProduct;
//# sourceMappingURL=audit-product.js.map